// extracted by mini-css-extract-plugin
module.exports = {"successToastr":"Router_successToastr__20xrI","errorToastr":"Router_errorToastr__11FD_","warningToastr":"Router_warningToastr__3bll3","infoToastr":"Router_infoToastr__2NgLk"};